import moment from 'moment'
import echarts from '@/config/echarts'
// 道路结冰
export const getIcyRaod = () => {
  return {
    color: ['rgba(37, 215, 201, 1)', '#80B3FF', '#F6AB00'],
    title: {
      show: true,
      text: '',
      left: 50,
      top: 0,
      textStyle: { // 标题样式
        color: '#ffb700', // 字体颜色
        fontSize: '0.9rem', // 字体大小
        fontWeight: 400, // 字体粗细
        align: 'center', // 文字水平对齐方式（left/right）
        verticalAlign: 'middle' // 文字垂直对齐方式（top/bottom）
      }
    },
    tooltip: {
      trigger: 'axis',
      show: true,

      formatter: function (params) {
        var result = ''
        var dotHtml1 = '<span style="display:inline-block;margin-right:0.26vw;border-radius:0.52vw;width:0.52vw;height:0.52vw;background-color:rgba(37, 215, 201, 1)"></span>'
        var dotHtm2 = '<span style="display:inline-block;margin-right:0.26vw;border-radius:0.52vw;width:0.52vw;height:0.52vw;background-color:#80B3FF"></span>'
        var dotHtm3 = '<span style="display:inline-block;margin-right:0.26vw;border-radius:0.52vw;width:0.52vw;height:0.52vw;background-color:#F6AB00"></span>'
        result += moment(Number(params[0].axisValue)).format('DD日HH时') + '</br>' + dotHtml1 + ' 降水 ' + params[0].data + 'mm' + '</br>' + dotHtm2 + ' 气温 ' + params[1].data + '℃' + '</br>' + dotHtm3 + ' 路温 ' + params[2].data + '℃'
        return result
      }
    },
    legend: {
      show: true,
      top: 0,
      right: 60,
      itemWidth: 14,
      itemHeight: 9,
      itemGap: 10,
      icon: 'circle',
      textStyle: {
        color: '#FFF',
        fontSize: '0.7.4rem'
      }

    },
    grid: {
      top: 30,
      bottom: 20
    },
    xAxis: {
      axisTick: { length: 5 },
      axisLine: {
        onZero: false
      },
      axisLabel: {
        color: '#FFF',
        fontSize: '0.9rem',
        formatter: function (value) {
          return moment(Number(value)).format('HH:00')
        }
      },
      // axisLabel: {
      //   // y轴文字的配置
      //   // rotate: -25,
      //   textStyle: {
      //     fontSize: 14,
      //     color: '#FFF',
      //     margin: 15
      //   },
      //   formatter: function (value, index) {
      //     return moment(Number(value)).format('DD日HH时')
      //   }
      //   // formatter: '{value} %'//y轴的每一个刻度值后面加上‘%’号
      // },

      data: []
    },
    yAxis: [
      {
        type: 'value',
        name: '(℃)',
        nameLocation: 'end',
        nameTextStyle: {
          color: '#FFF',
          fontSize: '0.9rem',
          align: 'right'
        },
        splitLine: {
          show: false
        },
        splitNumber: 4,
        axisLabel: {
          color: '#FFF',
          fontSize: '0.9rem'
        },
        min: function (value) {
          return Math.floor(Number(value.min)) - 3
        },
        max: function (value) {
          return Math.floor(Number(value.max)) + 3
        }
      },
      {
        type: 'value',
        name: '(mm)',
        nameLocation: 'end',
        nameTextStyle: {
          color: '#FFF',
          fontSize: '0.9rem',
          align: 'left'
        },
        splitLine: {
          show: false
        },
        axisLabel: {
          color: '#FFF',
          fontSize: '0.9rem'
        },
        max: function (value) {
          return Math.floor(Number(value.max)) + 2
        }
      }
    ],
    series: [
      {
        name: '降水',
        data: [120, 200, 150, 80],
        type: 'bar',
        yAxisIndex: 1,
        barWidth: 5,
        backgroundStyle: {
          color: '#E3E9EF',
          borderRadius: [0, 5, 5, 0]
        },
        label: {
          show: false,
          position: 'right',
          color: '#333333'
        }

      },
      {
        name: '气温',
        data: [120, 200, 150, 80],
        type: 'line',
        yAxisIndex: 0,
        symbol: (value, params) => {
          if (params.dataIndex % 3 === 0) {
            return 'circle'
          } else {
            return 'none'
          }
        },
        smooth: true,
        label: {
          show: false,
          position: 'right',
          color: '#333333'
        },
        itemStyle: {
          normal: {
            lineStyle: {
              width: 0.7// 0.1的线条是非常细的了
            }
          }
        }

      },
      {
        name: '路温',
        data: [120, 200, 150, 80],
        type: 'line',
        yAxisIndex: 0,
        symbol: (value, params) => {
          if (params.dataIndex % 3 === 0) {
            return 'circle'
          } else {
            return 'none'
          }
        },
        smooth: true,
        label: {
          show: false,
          position: 'right',
          color: '#333333'
        },
        itemStyle: {
          normal: {
            lineStyle: {
              width: 0.7// 0.1的线条是非常细的了
            }
          }
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: 'rgba(246, 171, 0, 0.16)'
            },
            {
              offset: 1,
              color: 'rgba(246, 171, 0, 0)'
            }
          ])
        }

      }
    ]
  }
}
